/* eslint-disable */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import JsonExcel from "vue-json-excel";

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import VueBarcode from 'vue-barcode'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/sweet-alerts'
import VueCurrencyInput from 'vue-currency-input'

// Axios Mock Adapter
import '@/@fake-db/db'
import vueXlsxTable from 'vue-xlsx-table'

Vue.use(vueXlsxTable, { rABS: false }) //浏览器的FileReader API 有两个方法可以读取本地文件 readAsBinaryString 和 readAsArrayBuffer, 默认rABS为false，也就是使用readAsArrayBuffer

Vue.component("downloadExcel", JsonExcel);
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core stylesZ
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import assets styles
require('@/assets/css/style.css')

// currency
Vue.use(VueCurrencyInput)

Vue.component('barcode', VueBarcode)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
